import React from 'react'
import { View, Text } from 'react-native'
import Colors from '../../../constants/Colors';
import CS from '../../../constants/Styles';
import { Button, AddressPicker } from '../../../components';
import UserAvatar from '../../../components/Users/UserAvatar';
import Constants from 'expo-constants';
import styles from './styles';

export const LocationChange = ({ item, acceptChange, rejectChange, makeChange }) => {
  const [address, setAddress] = React.useState(item.new_value);
  const [streetId, setStreetId] = React.useState(null);
  const [streetNumber, setStreetNumber] = React.useState(null);
  const [addressUnit, setAddressUnit] = React.useState(null);

  const [editable, setEditable] = React.useState(false);
  let textInput = React.useRef(null);

  const accept = () => {
    console.log('accept()');
    acceptChange(item);
  }
  const reject = () => {
    console.log('reject()');
    rejectChange(item);
  }

  const makeAChange = () => {
    console.log('makeAChange');
    setEditable(true);
    setTimeout(() => {
      textInput.current.focus();
    }, 100);
  }
  const saveChange = () => {
    if (item.address_new_data.street_id !== streetId || item.address_new_data.adress_number !== streetNumber) {
      let newVal = {
        streetId: streetId,
        streetNumber: streetNumber,
      };
      if(addressUnit){
        newVal.addressUnit = addressUnit;
      }
      makeChange(item, newVal);
    }
    console.log('saveChange')
    // setEditable(false);
  }
  const cancelChange = () => {
    setStreetId(null);
    setStreetNumber(null);
    setAddressUnit(null);
    setEditable(false);
  }

  return (
    <View>
      {/* <Text style={[CS.smallTitle, CS.lightText]}>Location</Text> */}
      <View style={[CS.rowContainer, { marginBottom: 20 }]}>
        <UserAvatar userId={item.avatar.id} avatar={item.avatar.version} size='medium' />
        <Text style={[CS.smallText, CS.lightBlueText, { marginLeft: 10 }, CS.flex]}>{item.memo}</Text>
      </View>
      <Text style={[CS.smallText, CS.lightBlueText, CS.boldText, { marginBottom: 10 }]}>From</Text>
      <View style={styles.oldLocation}>
        <Text style={[CS.smallText, CS.lightBlueText]}>{item.old_value}</Text>
      </View>
      <Text style={[CS.smallText, CS.lightBlueText, CS.boldText, { marginBottom: 10 }]}>To</Text>
      {!editable &&
        <View style={styles.newLocation}>
          <Text style={[CS.smallText, CS.blueText]}>{item.new_value}</Text>
        </View>
      }
      {editable &&
        <AddressPicker
          placeholder='Where is the project located?'
          value={address}
          setAddress={setAddress}
          setStreetId={setStreetId}
          setStreetNumber={setStreetNumber}
          setAddressUnit={setAddressUnit}
          offsetTop={Constants.statusBarHeight}
          // outerInputContainerStyle={styles.marginContainer}
          inputRef={textInput}
          // setIsInvalid={setIsInvalidLocation}
          editable={editable}
        />
      }
      {/* {!item.completed &&  */}
      {!editable && 
        <View style={[CS.rowContainer, { marginTop: 10 }]}>
          <View style={styles.buttonLeft}>
            <Button text='Accept' onPress={() => accept} />
          </View>
          <View style={styles.buttonMiddle}>
            <Button text='Reject' onPress={() => reject} color='red' />
          </View>
          <View style={styles.buttonRight}>
            <Button text='Change' onPress={() => makeAChange} color='blue' />
          </View>
        </View>
      }
      {editable &&
        <View style={[CS.rowContainer, { marginTop: 10, marginBottom: 10 }]}>
          <View style={CS.buttonLeft}>
            <Button text='Save' onPress={() => saveChange} color='blue' />
          </View>
          <View style={CS.buttonRight}>
            <Button text='Cancel' onPress={() => cancelChange} color='red' />
          </View>
        </View>
      }
    </View>
  );
}

export default LocationChange;